<app-left-side-nav></app-left-side-nav>
<app-header></app-header>

<!-- page content area start-->
<div *ngIf="!isLoading" class="afterLoginPageContainer">
  <div class="mainContent">
    <div class="virtualEvent">
      <div class="backLink" (click)="goBack()">
        <i class="fa fa-chevron-left me-3"></i> Virtual Event
      </div>

      <div class="list mt-4">
        <div class="sec mb-3 digital" (click)="gotoDigitalCatalog()">
          <!-- <span class="coming">Coming Soon</span> -->
          <div class="arrow"><i class="fa fa-arrow-right"></i></div>
          <h4 class="font-weight-600">Digital Catalog</h4>
          <p class="mb-0">Explore pavilions, exhibitors and products at KISAN.</p>
        </div>

        <div class="sec mb-3 special">
          <span class="coming">Coming Soon</span>
          <h4 class="font-weight-600">Special Offers</h4>
          <p class="mb-0">Get amazing offers from exhibitors. Redeem at their stall in KISAN.</p>
        </div>

        <div class="sec mb-3 quest">
          <span class="coming">Coming Soon</span>
          <h4 class="font-weight-600">KISAN Quest</h4>
          <p class="mb-0">Explore the best competitions, vote for your favourite ideas and download material.</p>
        </div>

        <div class="sec mb-3 initiatives">
          <span class="coming">Coming Soon</span>
          <h4 class="font-weight-600">KISAN Initiatives</h4>
          <p class="mb-0">Unique initiatives to raise awareness on crucial agriculture issues.</p>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- <button *ngIf="!isLoading" data-bs-toggle="modal" data-bs-target="#virtualPassModal" type="submit" class="btn subBtn">Continue</button> -->